import React, { useEffect, useState } from "react";
import TaskProduct from "./TaskProduct/TaskProduct";
import ProjectTaskAPIs from "../../../../../../../../MasonyFixingsAPIs/ProjectTaskAPIs/ProjectTaskAPIs";
import AddTaskProduct from "./AddTaskProduct";
import { Card, Row, Col, Table } from "react-bootstrap";
import { MdAddCircle } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ApiResponseHandler from "../../../../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { useToast } from "../../../../../../../../Contexts/ToastContext";

export default function ViewTaskProducts({projectTaskID}){

    const {addToast} = useToast();
    const ColumnHeaders = ['Product', 'Quantity', '', ''];
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [taskProducts, setTaskProducts] = useState([])
    const getTaskProducts = (projectTaskID) => {
        ProjectTaskAPIs.GetProjectTaskProductList(projectTaskID)
        .then((response) => {
            if(response.status === 200){
                setTaskProducts(response.data);
                setLoading(false);
            }
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    const thData = () => {

        return ColumnHeaders.map((header, index) => {
            return(
                <th key={index}>{header}</th>
            )
        })
    }

    const handleAddNew = () => {
        getTaskProducts(projectTaskID);
        setAddNew(false);
    }

    useEffect(() => {
        getTaskProducts(projectTaskID);
    }, [projectTaskID])


    if(loading){
        return(
            <div>Loading Products...</div>
        )
    }

    return(
        <div>
                
            <AddTaskProduct projectTaskID={projectTaskID} handleAddNew={handleAddNew} />

            {taskProducts.length > 0 ? 
            taskProducts.map((product) => {
                return(
                    <TaskProduct key={product.id} getTaskProducts={getTaskProducts} projectTaskID={projectTaskID} taskProductID={product.id} />
                )
            })
            :
            <div>No Products yet</div> 
            }
                
                    
        </div>
    )

}